import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, Inbox, Package } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const linkClass = ({ isActive }) =>
  `inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium tracking-wide transition-colors border ${
    isActive
      ? "bg-[#1B3A5C] text-white border-[#1B3A5C]"
      : "bg-white text-[#1B3A5C] border-[#E2E8F0] hover:bg-[#F1F5F9]"
  }`;

export const AdminShell = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div data-testid="admin-shell" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-start justify-between gap-4 flex-wrap mb-8">
        <div>
          <div className="sb-mono-label">Admin · Internal</div>
          <h1
            className="mt-2 text-4xl font-semibold text-[#1B3A5C] tracking-tight"
            style={{ fontFamily: "Outfit" }}
          >
            Sterling Bio control
          </h1>
          {user ? (
            <p className="mt-2 text-sm text-[#64748B]">
              Signed in as <span className="font-mono text-[#1B3A5C]">{user.email}</span>
            </p>
          ) : null}
        </div>
        <button
          data-testid="admin-logout"
          onClick={handleLogout}
          className="inline-flex items-center gap-2 border border-[#1B3A5C] text-[#1B3A5C] hover:bg-[#1B3A5C] hover:text-white px-4 py-2 text-sm font-medium tracking-wide transition-colors"
        >
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </div>

      <nav className="flex flex-wrap gap-0 mb-8">
        <NavLink to="/admin/orders" data-testid="admin-nav-orders" className={linkClass}>
          <Inbox className="w-4 h-4" /> Orders
        </NavLink>
        <NavLink
          to="/admin/products"
          data-testid="admin-nav-products"
          className={({ isActive }) =>
            `${linkClass({ isActive })} -ml-px`
          }
        >
          <Package className="w-4 h-4" /> Products
        </NavLink>
      </nav>

      <Outlet />
    </div>
  );
};

export default AdminShell;
